
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/angles-i-llengues",
      function () {
        return require("private-next-pages/corporatiu/angles-i-llengues/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/angles-i-llengues"])
      });
    }
  